module.exports = __webpack_public_path__ + "img/logo.d8d785a2.png";